var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height"},[_c('v-row',{staticClass:"justify-center"},[_c('v-col',{attrs:{"cols":"12","lg":"4"}},[_c('router-view')],1),_c('crm-flash-message')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }